import type { SubscriptionTier } from './planFeatures';

/** Currencies used for Stripe subscription catalog prices (not lesson/checkout currencies). */
export type SubscriptionBillingCurrency = 'USD' | 'AUD' | 'GBP' | 'EUR';

export type MonthlyPriceByCurrency = Record<SubscriptionBillingCurrency, number>;

/**
 * Monthly subscription list prices in major currency units (tax inclusive).
 * Yearly Stripe prices use monthly × 12 × 0.8 (20% annual discount).
 *
 * GBP/EUR are pre-provisioned for upcoming GB/EU market rollout (feature-flagged in app).
 */
export const SUBSCRIPTION_MONTHLY_PRICING: Record<SubscriptionTier, MonthlyPriceByCurrency> = {
  starter: { USD: 29, AUD: 45, GBP: 25, EUR: 27 },
  professional: { USD: 99, AUD: 149, GBP: 85, EUR: 95 },
  enterprise: { USD: 249, AUD: 379, GBP: 215, EUR: 245 },
};

export const SUBSCRIPTION_BILLING_CURRENCIES: readonly SubscriptionBillingCurrency[] = [
  'USD',
  'AUD',
  'GBP',
  'EUR',
];

/** Stripe Price.currency values (lowercase). */
export const STRIPE_SUBSCRIPTION_CURRENCY_CODES: Record<
  SubscriptionBillingCurrency,
  'usd' | 'aud' | 'gbp' | 'eur'
> = {
  USD: 'usd',
  AUD: 'aud',
  GBP: 'gbp',
  EUR: 'eur',
};

export function subscriptionYearlyAmountMajor(monthlyMajor: number): number {
  return monthlyMajor * 12 * 0.8;
}

export function subscriptionMonthlyAmountCents(monthlyMajor: number): number {
  return Math.round(monthlyMajor * 100);
}

export function subscriptionYearlyAmountCents(monthlyMajor: number): number {
  return Math.round(subscriptionYearlyAmountMajor(monthlyMajor) * 100);
}
